import { render, staticRenderFns } from "./PrecontractTemplateView.vue?vue&type=template&id=65542e0d&"
import script from "./PrecontractTemplateView.vue?vue&type=script&lang=js&"
export * from "./PrecontractTemplateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports